import type { ReactNode } from 'react';
import finnLogo from '../../../../assets/finn-logo.png';
import type { JoinLanguage } from '../../services/talentJoinApi';
import { JOIN_COPY } from './joinCopy';

/**
 * The frame every public Talent Community page shares: logo, language switch and — until legal
 * has signed off — a banner saying this is a preview. The banner is driven by the proxy's own
 * switch, so the page cannot claim to be live while the server still turns candidates away.
 */
export function JoinShell({
  language,
  onLanguage,
  live,
  children,
}: {
  language: JoinLanguage;
  onLanguage: (l: JoinLanguage) => void;
  live: boolean | undefined;
  children: ReactNode;
}) {
  const copy = JOIN_COPY[language];
  return (
    <div className="min-h-screen bg-gray-50">
      {live === false && (
        <div role="status" className="border-b border-amber-300 bg-amber-50 px-4 py-2 text-center text-sm text-amber-900">
          {copy.preview}
        </div>
      )}
      <div className="mx-auto max-w-xl px-4 py-10">
        <header className="mb-6 flex items-center justify-between">
          <img src={finnLogo} alt="FINN" className="h-7 w-auto" />
          <div className="flex gap-1 text-sm" role="group" aria-label="Language / Sprache">
            {(['de', 'en'] as const).map((l) => (
              <button
                key={l}
                type="button"
                onClick={() => onLanguage(l)}
                aria-pressed={language === l}
                className={
                  language === l
                    ? 'rounded-sm bg-gray-900 px-2 py-1 font-medium text-white'
                    : 'rounded-sm px-2 py-1 text-gray-600 hover:bg-gray-200'
                }
              >
                {l.toUpperCase()}
              </button>
            ))}
          </div>
        </header>
        <main className="rounded border border-gray-200 bg-white p-6 sm:p-8">{children}</main>
      </div>
    </div>
  );
}
